import { render } from "./MovieCard.vue?vue&type=template&id=48e2dc0d"
import script from "./MovieCard.vue?vue&type=script&lang=js"
export * from "./MovieCard.vue?vue&type=script&lang=js"
script.render = render

export default script